import React, { useEffect } from "react";
import './maskBackground.css';

interface MaskBackgroundProps {
    zIndex?: number;
    closeFunction?: () => void;
}
let scrollLockCount = 0;
let savedScrollY = 0;
const MaskBackground: React.FC<MaskBackgroundProps> = ({ zIndex = 1, closeFunction }) => {
    useEffect(() => {
        if (scrollLockCount === 0) {
            savedScrollY = window.scrollY;

            document.body.classList.add("scroll-lock");
            document.body.style.top = `-${savedScrollY}px`;
        }
         scrollLockCount += 1;

        return () => {
            scrollLockCount = Math.max(0, scrollLockCount - 1);

            if (scrollLockCount === 0) {
                document.body.classList.remove("scroll-lock");
                document.body.style.top = "";

                window.scrollTo(0, savedScrollY);
            }
            };
    }, []);

    return (
        <div
            className="containerMaskBackground"
            style={{ zIndex }}
            onClick={() => {
                if (closeFunction) closeFunction();
            }}
        />
    );
};

export default MaskBackground;
